import { TId } from '@/features/common';

import { EAutomationType } from './automations';

export const TRIGGERABLE_AUTOMATIONS = [
  EAutomationType.SendEmailToMovedCandidate,
  EAutomationType.SendTestInviteToMovedCandidate,
] as const;

export type TAutomationTriggerType = (typeof TRIGGERABLE_AUTOMATIONS)[number];

export type TTriggerNotificationSettings = {
  type: TAutomationTriggerType;
  title: React.ReactNode;
  description: (candidateCount: number) => React.ReactNode;
  successMessage: string;
};

type TTriggerAutomationSettings = {
  workspaceId: TId;
  jobOpeningId: TId;
  stageId: TId;
  automationId: TId;
  candidateIds: TId[];
};

export type TAutomationTrigger = TTriggerAutomationSettings &
  TTriggerNotificationSettings;

export type TAutomationTriggerInput = TTriggerAutomationSettings &
  Pick<TTriggerNotificationSettings, 'type'> &
  Partial<Omit<TTriggerNotificationSettings, 'type'>>;

export type TAutomationTriggerMap = Map<TId, TAutomationTrigger>;
